import { Base } from '../../01_base/base';
import { Logger } from '../../02_utils/logger';
import { Utils } from '../../02_utils/utils';

export class OnePageNavigation {
  private navigation: boolean = document.querySelector('.js-l-navigation')?.classList.contains('js-l-one-page-navigation');
  private onePageNaviation: string = '';
  private headerNavigation: HTMLElement = document.querySelector('.js-l-navigation__level-1 ul');

  constructor(private $log: Logger, private $utils: Utils, private $base: Base) {
    if (this.navigation) {
      this.initOnePageNavigation();
    }
  }

  /**
   * Creates a custom one page navigation by given area names.
   * The data-target is a timestamp which will be used as reference for the link.
   * The custom navigation will be placed in the default navigation HTML.
   * The Base class provides the anchorNavigation function for the scrolling.
   */
  private initOnePageNavigation(): void {
    const areaBricks: NodeListOf<HTMLElement> = document.querySelectorAll('section.js-anchor-target');
    const header: HTMLElement = document.querySelector('.js-l-header');

    areaBricks?.forEach((areaBrick: HTMLElement) => {
      const areaBrickName = areaBrick.dataset.areaName;
      const areaBrickTarget = areaBrick.dataset.target;

      if (areaBrickName != '') {
        this.buildOnePageNavigation(areaBrickName, areaBrickTarget);
      }
    });

    if (this.onePageNaviation != '') {
      this.headerNavigation.innerHTML = this.onePageNaviation;
      this.$base.anchorNavigation(this.$utils.elementHeight(header));
      this.$utils.scrollPosition.subscribe(() => {
        areaBricks?.forEach((areaBrick: HTMLElement) => {
          const areaBrickTarget = areaBrick.dataset.target;
          const navLink: HTMLElement = document.querySelector(`.js-anchor-link[href="${areaBrickTarget}"]`);

          if (navLink) {
            if (this.$utils.isInViewport(areaBrick, this.$utils.elementHeight(header))) {
              this.$utils.addOrRemoveClases('add', 'active', navLink);
            } else {
              this.$utils.addOrRemoveClases('remove', 'active', navLink);
            }
          }
        });
      });
    }
  }

  private buildOnePageNavigation(navTitle: string, navTarget: string): void {
    this.onePageNaviation += `<li><a href="${navTarget}" class="js-anchor-link">${navTitle}</a></li>`;
  }
}
